enum CompanyActionTypes {
  LOAD_STATE = 'LOAD_STATE',
  SET_LOCATIONS = 'SET_LOCATIONS',
  SET_USERS = 'SET_USERS',
  SET_CLIENTS = 'SET_CLIENTS',
  SET_CAREPARTNERS = 'SET_CAREPARTNERS',
  RESET = 'RESET',
  SET_CARE_MANAGER_ACTIVITIES = 'SET_CARE_MANAGER_ACTIVITIES',
  SET_APPLICANTS = 'SET_APPLICANTS',
  SET_AWARD_TYPES = 'SET_AWARD_TYPES',
  SET_DEACTIVATION_REASONS='SET_DEACTIVATION_REASONS',
  SET_LOST_CLIENT_REASONS='SET_LOST_CLIENT_REASONS',
  SET_APPLICANT_STAGES='SET_APPLICANT_STAGES',
  SET_REFERRAL_PARTNERS='SET_REFERRAL_PARTNERS',
  SET_COMPANIES='SET_COMPANIES',
  SET_PROSPECT = 'SET_PROSPECT',
  SET_MILESTONES = 'SET_MILESTONES',
  SET_RATINGS = 'SET_RATINGS',
  SET_COMPANY_RATINGS = 'SET_COMPANY_RATINGS',
  SET_ACTIVITY_TYPES = 'SET_ACTIVITY_TYPES',
  SET_COMPANY_TYPES = 'SET_COMPANY_TYPES',
  SET_APPLICANT_ACTIVITY='SET_APPLICANT_ACTIVITY',
  SET_LEAD_SOURCES='SET_LEAD_SOURCES',
  SET_REFERRAL_ACTIVITY_TYPES='SET_REFERRAL_ACTIVITY_TYPES',
}

export { CompanyActionTypes };
